import React, { useState, useEffect, useRef } from 'react';
import classes from "./Corousel.module.css";
import { addWishlistItem, deleteWishlistItem } from '../../../Store/actions/WishlistAction';
import { useDispatch, useSelector } from 'react-redux';
import { urls } from '../../../Routes/Urls';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import Card from "../Card/Card2"
import { getRandomImageForBestSellerBook } from '../../../Util';
import NextArrow, { PrevArrow } from '../../../Components/Arrows/Arrows';
import useScreenSize from '../../../Hooks/UseScreenSize';
const listingDecoration = '/Assets/Images/listingDecoration.svg'

const getNumberOfVisibleItems = () => {
  if (window.innerWidth >= 1200) return 3.5;
  if (window.innerWidth >= 768) return 2;
  return 1;
};

const Carousel = () => {
  const currentUser = useSelector(state => state.user.currentUser)
  const [current, setCurrent] = useState(0);
  const [visibleItems, setVisibleItems] = useState(getNumberOfVisibleItems());
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);
  const autoScrollRef = useRef(null);
  
  const dispatch = useDispatch()
  const allColorsData = useSelector((state) => state.bookColor.colors);
  const history = useHistory()
  const featuredCollection = useSelector(state => state.featured.featuredCollection);
  const wishlist = useSelector((state) => state.wishlist.wishlistItems);
  const books = featuredCollection?.find((data) => data.category === "newlyCrafted")?.books || [];
  const { isSmallScreen } = useScreenSize()

  // Minimum swipe distance (in px)
  const minSwipeDistance = 50;

  const onTouchStart = (e) => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
  };

  const onTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;
    
    if (isLeftSwipe) {
      nextSlide();
    }
    if (isRightSwipe) {
      prevSlide();
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setVisibleItems(getNumberOfVisibleItems());
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    autoScrollRef.current = setInterval(() => {
      if (books.length > 0) {
        setCurrent((prevCurrent) => (prevCurrent + 1) % books.length);
      }
    }, 3000);

    return () => clearInterval(autoScrollRef.current);
  }, [books.length]);

  // Pause auto-scroll when user is interacting
  const pauseAutoScroll = () => {
    if (autoScrollRef.current) {
      clearInterval(autoScrollRef.current);
    }
  };

  // Resume auto-scroll after interaction
  const resumeAutoScroll = () => {
    autoScrollRef.current = setInterval(() => {
      if (books.length > 0) {
        setCurrent((prevCurrent) => (prevCurrent + 1) % books.length);
      }
    }, 3000);
  };

  const nextSlide = () => {
    setCurrent((prevCurrent) => (prevCurrent + 1) % books.length);
  };

  const prevSlide = () => {
    setCurrent((prevCurrent) => (prevCurrent - 1 + books.length) % books.length);
  };

  const isEmpty = (obj) => {
    return Object.keys(obj).length === 0;
  };

  const isWishListItem = (bookData) => {
    const bookOpt = wishlist?.find((item) => item?.book?.sku === bookData.sku && item?.book?.title === bookData?.title)
    return bookOpt ? { isPresent: true, data: bookOpt } : { isPresent: false, data: null }
  }

  const handleAddCart = (bookData) => {
    history.push({
      pathname:`${urls.BESTSELLERPDP}/${bookData?.id}/${bookData?.title_slug}`,
      state: {bookData}
  });
  }

  const handleWishlistChange = (e, book) => {
    e.stopPropagation()
    if (isEmpty(currentUser)) {
      history.push(urls.LOGIN)
    } else {
      addWishlistItem(book, 1, dispatch, true)
    }
  }

  const handleRemove = (e, itemId) => {
    e.stopPropagation()
    deleteWishlistItem(itemId, dispatch);
  };

  return (
    <div className={classes.container}>
      <div className={classes.carousel}>
        <div className={classes.header}>
          <div className={classes.newlyHeader}>
            <h2>Newly crafted books</h2>
            <img src={listingDecoration} alt="" />
          </div>
          {!isSmallScreen && <div className={classes.carouselBtn}>
            <PrevArrow
              className={`${classes.carouselControl} ${classes.prev}`}
              onClick={prevSlide}
            />
            <NextArrow
              className={`${classes.carouselControl} ${classes.next}`}
              onClick={nextSlide}
            />
          </div>}
        </div>
      </div>
      <div className={classes.mainCarousel}>
        {isSmallScreen && <div className={classes.carouselBtn}>
          <PrevArrow
            className={`${classes.carouselControl} ${classes.prev}`}
            onClick={prevSlide}
          />
          <NextArrow
            className={`${classes.carouselControl} ${classes.next}`}
            onClick={nextSlide}
          />
        </div>}
        <div
          className={classes.carouselInner}
          style={{
            transform: `translateX(-${current * (100 / visibleItems)}%)`,
            transition: 'transform 0.3s ease-in-out'
          }}
          onTouchStart={onTouchStart}
          onTouchMove={onTouchMove}
          onTouchEnd={onTouchEnd}
          onMouseEnter={pauseAutoScroll}
          onMouseLeave={resumeAutoScroll}
        >
          {books.map((book, index) => (
            <div
              key={index}
              className={`${classes.carouselItem} ${current === index ? classes.active : ""}`}
            >
              <Card 
                image={book?.imageUrl} 
                onClick={() => handleAddCart(book)} 
                altText={getRandomImageForBestSellerBook(book, allColorsData)?.altText} 
                key={index} 
                price={book?.leatherType === "realLeather" ? book?.priceGenuine?.toFixed(2) :book?.priceVegan?.toFixed(2)} 
                bookData={book} 
                isWishListItem={isWishListItem(book).isPresent} 
                wishlistItemId={isWishListItem(book)?.data?.id} 
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Carousel;